export const FleetRoles = Object.freeze({
  OWNER: "OWNER",
  EXECUTIVE: "EXECUTIVE",
  OPERATIONS: "OPERATIONS",
  MAINTENANCE: "MAINTENANCE",
  HHRR: "HHRR",
});

const SETUP_ROLES = new Set([FleetRoles.OWNER, FleetRoles.EXECUTIVE]);
const BILLING_ROLES = new Set([FleetRoles.OWNER, FleetRoles.EXECUTIVE]);
const DRIVERS_ROLES = new Set([FleetRoles.OWNER, FleetRoles.EXECUTIVE, FleetRoles.OPERATIONS, FleetRoles.HHRR]);
const LIBRARY_ROLES = new Set([FleetRoles.OWNER, FleetRoles.EXECUTIVE, FleetRoles.OPERATIONS, FleetRoles.HHRR]);
const TRANSPORTS_ROLES = new Set([FleetRoles.OWNER, FleetRoles.EXECUTIVE, FleetRoles.OPERATIONS]);
const WELCOME_MAP_ROLES = new Set([FleetRoles.OWNER, FleetRoles.EXECUTIVE, FleetRoles.OPERATIONS]);

export function normalizeFleetRole(value) {
  const normalized = String(value || "").trim().toUpperCase();
  return Object.values(FleetRoles).includes(normalized) ? normalized : null;
}

export function getFleetRoleLabel(role, t) {
  const normalized = normalizeFleetRole(role);
  if (!normalized) {
    return String(role || "");
  }

  const translationKeyByRole = {
    [FleetRoles.OWNER]: "roles.owner",
    [FleetRoles.EXECUTIVE]: "roles.executive",
    [FleetRoles.OPERATIONS]: "roles.operations",
    [FleetRoles.MAINTENANCE]: "roles.maintenance",
    [FleetRoles.HHRR]: "roles.hhrr",
  };

  const translationKey = translationKeyByRole[normalized];
  if (!translationKey || typeof t !== "function") {
    return normalized;
  }

  return t(translationKey, { defaultValue: normalized });
}

export function canAccessSetup(role) {
  return SETUP_ROLES.has(role);
}

export function canAccessBilling(role) {
  return BILLING_ROLES.has(role);
}

export function canAccessDrivers(role) {
  return DRIVERS_ROLES.has(role);
}

export function canAccessLibrary(role) {
  return LIBRARY_ROLES.has(role);
}

export function canAccessTransports(role) {
  return TRANSPORTS_ROLES.has(role);
}

export function canAccessWelcome(role) {
  return WELCOME_MAP_ROLES.has(role);
}

export function canAccessMap(role) {
  return WELCOME_MAP_ROLES.has(role);
}

export function canUseFleetUI(role) {
  return Boolean(role);
}

export function isManagerRole(role) {
  return role === FleetRoles.OWNER || role === FleetRoles.EXECUTIVE;
}

export function canManageBranding(role) {
  return role === FleetRoles.OWNER;
}
